import React from "react";
import * as actions from '../Actions';

export default function AnswerOverlay({ eleRef }) {
    return (
        <div className="addAns-overlay" onClick={(e) => actions.closeAnswerPopup(e)}>
            <div className="addAns-popup">
                <div className="addAns-header">
                    <span className="M18_48">Add An Answer</span>
                    <span className="closeButton icon" data-icon-font="C" onClick={(e) => actions.closeAnswerPopup(e)}></span>
                </div>
                <div className="write-comment-container">
                    <input type="hidden" id="answer_queId" value="" />
                    <input type="hidden" id="answer_queUserId" value="" />
                    <textarea id="post_answer_text" rows="4" cols="50" className="comment-box L14_74" placeholder="Write your Answer here"></textarea>
                    <label htmlFor="fileupload">
                        <div className="qna-popup-attachment">
                            <div data-icon-font="o" className="icon R16_9e"></div>
                            <span className="R14_61">Attachments</span>
                        </div>
                    </label>
                    <div className="file_upload_err"></div>
                    <p className="b_1 right postcomment" id="devpostanswers" onClick={() => actions.postAnswer(eleRef)}>Post Answer</p>
                    <div className="uploaded-files-list">
                        <ul>
                            <li className="cmt-image">
                                <span data-icon-font="`" className="icon left"></span>
                                <span className="added-file-name left"></span>
                                <span data-icon-font="&#xe013;" className="icon right" onClick={() => actions.cmtFileDelete('image', "ans")}></span>
                            </li>
                            <li className="cmt-pdf">
                                <span data-icon-font="&#xe039;" className="icon left"></span>
                                <span className="added-file-name left"></span>
                                <span data-icon-font="&#xe013;" className="icon right" onClick={() => actions.cmtFileDelete('pdf', "ans")}></span>
                            </li>
                        </ul>
                    </div>
                    <input type="file" id="fileupload" onChange={() => actions.cmtFileUpload()} style={{ display: 'none' }} />
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// src/shared/qna/common/AnswerOverlay.js